import css from './resultPane.module.scss';

import {
  TRepetitionAction,
  TRepetitionActionType,
} from 'core/helpers/repetition';
import KeyBind from 'core/ui/KeyBind';
import Kkb from 'core/ui/Kkb';

const RESET_NUM = 1;

type TKeyBindProps = {
  action: TRepetitionAction;
  handler: (event: TAnyEvent) => void;
  idx: number;
  disabled: boolean;
};
export const KkbBind: React.FC<TKeyBindProps> = ({
  action,
  handler,
  idx,
  disabled,
}) => {
  switch (action.type) {
    case TRepetitionActionType.reset:
      return (
        <KeyBind
          disabled={disabled}
          kkb={[`Digit${RESET_NUM}`, `Numpad${RESET_NUM}`]}
          onKeyPress={handler}
        />
      );

    case TRepetitionActionType.skip:
      return <KeyBind disabled={disabled} kkb="ArrowRight" onKeyUp={handler} />;

    case TRepetitionActionType.shift: {
      const key = idx;
      return (
        <KeyBind
          disabled={disabled}
          kkb={[`Digit${key}`, `Numpad${key}`]}
          onKeyPress={handler}
        />
      );
    }
  }
};

type TLabelProps = { action: TRepetitionAction; idx: number };
export const KkbLabel: React.FC<TLabelProps> = ({ action, idx }) => {
  switch (action.type) {
    case TRepetitionActionType.reset:
      return <Kkb className={css.kkb}>{RESET_NUM}</Kkb>;
    case TRepetitionActionType.skip:
      return <Kkb className={css.kkb}>→</Kkb>;
    case TRepetitionActionType.shift:
      return <Kkb className={css.kkb}>{idx}</Kkb>;
  }
};
